import { FC } from 'react'

import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'
import { StyledContainerLoader } from '@/components/LoaderContainer/containerloader.styles'

const ContainerLoader: FC<CircularProgressProps> = (circularProgressProps) => {
  return (
    <StyledContainerLoader>
      <CircularProgress color="inherit" data-testid="container-loader" {...circularProgressProps} />
    </StyledContainerLoader>
  )
}

export default ContainerLoader
